module.exports = __webpack_public_path__ + "img/old_5.54cef21a.jpg";